import { render, staticRenderFns } from "./scoringRuleSet.vue?vue&type=template&id=49922f7d&scoped=true&"
import script from "./scoringRuleSet.vue?vue&type=script&lang=js&"
export * from "./scoringRuleSet.vue?vue&type=script&lang=js&"
import style0 from "./scoringRuleSet.vue?vue&type=style&index=0&id=49922f7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49922f7d",
  null
  
)

export default component.exports